// Hook modyfikacji usługi pozycji oferty –
// PUT /sales-crm/clients/:cid/offers/:oid/positions/:pid/services/:id

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';
import type {
  OfferServicePriceType,
  ISalesCrmOfferService
} from 'api/endpoints/useGetSalesCrmOfferServices';

export interface IPutSalesCrmOfferServicePayload {
  serviceId: number | null;
  name: string | null;
  priceNet: number;
  priceGross: number | null;
  taxPercent: number;
  priceType: OfferServicePriceType;
}

type IResponse = ICommandResponseSuccess & Partial<ISalesCrmOfferService>;

const putSalesCrmOfferService = (
  clientId: number,
  offerId: string,
  positionId: number,
  serviceItemId: number,
  payload: IPutSalesCrmOfferServicePayload
): Promise<IResponse> =>
  axios.put(
    `/sales-crm/clients/${clientId}/offers/${offerId}/positions/${positionId}/services/${serviceItemId}`,
    payload
  );

export const usePutSalesCrmOfferService = (
  clientId: number,
  offerId: string,
  positionId: number,
  options?: UseMutationOptions<
    IResponse,
    IError,
    { id: number; payload: IPutSalesCrmOfferServicePayload }
  >
) =>
  useMutation(
    ({ id, payload }: { id: number; payload: IPutSalesCrmOfferServicePayload }) =>
      putSalesCrmOfferService(clientId, offerId, positionId, id, payload),
    options
  );
